<template>
    <router-view/>
</template>
<script>
export default {
    watch: {
        '$route.params.unitId': function (unitId) {
            this.init(unitId);
        }
    },
    beforeMount() {
        const {unitId} = this.$route.params;
        this.init(unitId);
    },
    beforeDestroy() {
        this.$store.dispatch('projects/project/units/unit/reset');
    },
    methods: {
        init(unitId) {
            this.$store.dispatch('projects/project/units/unit/init', unitId)
                .catch((message) => {
                    this.$dmv.notifyError(message);
                    this.$router.push({name: 'project-unit-default'});
                });
        }
    }
}
</script>
